var _defs, _g, _rect, _g2, _polygon, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 736.3 107.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: rgb(197, 214, 248);\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.4,26.4C2.3,34.3,0,43.2,0,52.7s2.3,18.4,6.4,26.2V26.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,16c-8.3,9.9-13.4,22.7-13.4,36.6s5,26.7,13.4,36.6V16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.7,8c-13.2,10.4-21.7,26.5-21.7,44.7s8.5,34.3,21.7,44.7V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.5,0c-20.8,8.4-35.5,28.8-35.5,52.7s14.7,44.2,35.5,52.7V0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120,74.6c.9,0,1.7,0,2.5,0l-6.4-10h10.9l4.4,7c6.2-3.8,10.1-10.8,10.1-19.7,0-13.6-9.3-22.9-21.6-22.9s-21.6,9.3-21.6,22.9,9.3,22.9,21.6,22.9M127.7,82.7c-2.4.6-5.1.9-7.7.9-17.2,0-31.3-12.5-31.3-31.8s14.1-31.8,31.3-31.8,31.4,12.5,31.4,31.8-5.9,22.3-14.9,27.5l5.9,9.2h-10.9l-3.7-5.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.5,65v-26.6h8.9v24.4c0,8.9,4.5,12.3,10.4,12.3s12.2-3.4,12.2-12.3v-24.4h8.9v43.8h-8.9v-6.5c-3.7,5.4-9.6,7.7-14.9,7.7-9.7,0-16.6-6.3-16.6-18.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.3,75.9c5.3,0,11-3.4,11-10v-4.6l-12,3.1c-4,1.1-5.6,2.9-5.6,5.9s3,5.7,6.6,5.7M213.7,70.8c0-7.2,4.2-11.1,12.7-13.4l14-3.7v-2.4c0-3.2-2.7-5.7-7.5-5.7s-7.7,1.5-8.9,6.6h-9.6c1.6-10,8.9-14.9,18.5-14.9s16.4,5.6,16.4,14.1v31h-8.9v-4.7c-3.1,4.3-8.4,5.9-12.9,5.9-7.8,0-13.7-4.3-13.7-12.8"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 262.1,
    y: 21.2,
    width: 8.9,
    height: 61.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.8,38.5h8.9v43.8h-8.9v-43.8ZM289.3,21.5c3.2,0,5.7,2.4,5.7,5.7s-2.4,5.7-5.7,5.7-5.7-2.4-5.7-5.7,2.4-5.7,5.7-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.9,69.7v-23.2h-7.8v-8h7.8v-11.3h8.9v11.3h11.1v8h-11.1v23.2c0,3,1.3,4.5,4.2,4.5h6.5v8h-6.5c-7.6,0-13.1-4.9-13.1-12.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.5,56.4c-1-8.3-6.9-11.7-12.5-11.7s-11.6,3.9-13,11.7h25.5,0ZM339,60.4c0-15.1,10.9-23.1,22.1-23.1s21.9,7.6,21.9,23.1v2.7h-35.1c1,8.3,6.7,12.4,13.6,12.4s8-1.5,10-4.4h10.4c-3.7,8.4-12.2,12.5-20.4,12.5s-22.5-8-22.5-23.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.9,56.4c-1-8.3-6.9-11.7-12.5-11.7s-11.6,3.9-13,11.7h25.5,0ZM392.3,60.4c0-15.1,10.9-23.1,22.1-23.1s21.9,7.6,21.9,23.1v2.7h-35.1c1,8.3,6.7,12.4,13.6,12.4s8-1.5,10-4.4h10.4c-3.7,8.4-12.2,12.5-20.4,12.5s-22.5-8-22.5-23.1"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "456.9 34.7 456.9 82.3 447.9 82.3 447.9 21.2 459.4 21.2 478.9 63.1 499 21.2 510.8 21.2 510.8 82.3 501.6 82.3 501.6 34 483.8 71.2 473.8 71.2 456.9 34.7"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M557,56.4c-1-8.3-6.9-11.7-12.5-11.7s-11.6,3.9-13,11.7h25.5,0ZM522.4,60.4c0-15.1,10.9-23.1,22.1-23.1s21.9,7.6,21.9,23.1v2.7h-35.1c1,8.3,6.7,12.4,13.6,12.4s8-1.5,10-4.4h10.4c-3.7,8.4-12.2,12.5-20.4,12.5s-22.5-8-22.5-23.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M598.7,75.2c7.8,0,13.7-5.3,13.7-14.8s-5.9-14.8-13.7-14.8-13.8,5.3-13.8,14.8,5.9,14.8,13.8,14.8M575.6,60.4c0-15.1,10.2-23.1,21.2-23.1s12,2.5,15.5,7.3v-23.4h8.9v61.1h-8.9v-6.1c-3.5,4.8-9,7.3-15.5,7.3-11,0-21.2-8-21.2-23.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M633.3,76.7c0-3.8,2.8-6.7,6.6-6.7s6.5,3,6.5,6.7-2.8,6.8-6.5,6.8-6.6-3-6.6-6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M729.9,81.2c4.1-7.9,6.4-16.8,6.4-26.2s-2.3-18.4-6.4-26.2v52.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M708.3,91.6c8.3-9.9,13.4-22.7,13.4-36.6s-5-26.7-13.4-36.6v73.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M686.5,99.6c13.2-10.4,21.7-26.5,21.7-44.7s-8.5-34.3-21.7-44.7v89.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M657.7,107.7c20.8-8.4,35.5-28.8,35.5-52.7s-14.7-44.2-35.5-52.7v105.3h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1581808ec8383d047b919b847697af76.svg";
export { ForwardRef as ReactComponent };